<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model.trim="search"
            dense
            outlined
            placeholder="Pesquisar"
            hide-details
            @keyup="getGruposContatos"
          />
        </v-col>

        <v-spacer />

        <salvar-grupo-contatos-dialog
          :is-dialog-open.sync="isCriarGrupoContatosDialogOpen"
          @refetch-data="getGruposContatos"
        />

        <v-col cols="auto">
          <v-btn
            color="success"
            @click.stop="isCriarGrupoContatosDialogOpen = !isCriarGrupoContatosDialogOpen"
          >
            <v-icon
              left
              size="25"
            >
              {{ icons.mdiPlus }}
            </v-icon>

            <span>Criar grupo de contatos</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <table-grupos-contatos
            :items="formularios"
            :headers="headers"
            :loading="loading"
            @refetch-data="getGruposContatos"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import { ref, onMounted } from '@vue/composition-api'
import TableGruposContatos from '@/components/tables/TableGruposContatos.vue'
import GruposContatosService from '@/services/modules/GruposContatosService'
import SalvarGrupoContatosDialog from '@/views/envio-em-massa/grupo-contatos/SalvarGrupoContatosDialog.vue'

export default {
  components: {
    SalvarGrupoContatosDialog,
    TableGruposContatos,
  },

  setup() {
    const isCriarGrupoContatosDialogOpen = ref(false)

    const search = ref('')
    const loading = ref(true)
    const formularios = ref([])

    async function getGruposContatos() {
      try {
        loading.value = true
        formularios.value = await GruposContatosService.get(search.value)
      } finally {
        loading.value = false
      }
    }

    onMounted(getGruposContatos)

    const headers = [
      { text: 'Nome', value: 'nome' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Qtd de contatos na lista', value: 'qtdeContatos', align: 'center' },
      {
        text: 'Opções',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      isCriarGrupoContatosDialogOpen,
      search,
      loading,
      formularios,
      getGruposContatos,
      headers,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>
